import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="starry-background">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
      <div id="title">
        <h1 className="about">ABOUT US</h1>
        <p>Welcome to Team Vyadh, a dynamic group of 76 like-minded students hailing from SEDS-VIT Projects at Vellore Institute of Technology (VIT), India. Specializing in the design and construction of Mars Rovers, our team is driven by a collective passion for innovation. With a focus on advancing science and technology, we excel in robotic-arm engineering, autonomous traversal, and state-of-the-art communication and data acquisition systems for the exploration of the Red Planet. Our proven track record includes participation in prestigious competitions such as URC, IRDC, ERC, and IRC, where we consistently demonstrate our expertise and absorb valuable insights from the forefront of the field. Join us on this exciting journey as we continue to push the boundaries of space exploration and leave an indelible mark on the world of robotics and technology.</p>
      </div>
    </div>
  );
};

export default AboutUs;
